import React, { useEffect } from 'react';
import {LoginForm} from '@/components';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {resetAuthMessage} from '@/services/redux/slices';
import {Routes as WebRoutes} from '@/navigation/Routes';
import { authFailureStatus, authSuccessStatus } from '@/services/redux/selectors';
import { ErrorCodes, getErrorMessage, getSuccessMessage, SuccessCodes } from '@/utils/getMessages';
import { useToast } from '@/hooks';
import { resetMessage } from '@/utils/common_functions';

export const LoginScreen: React.FC = () => {
  // ================================
  // hooks
  // ================================
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {showToast} = useToast();

  // ================================
  // selectors
  // ================================
  const authSuccess = useSelector(authSuccessStatus) as SuccessCodes;
  const authFailure = useSelector(authFailureStatus) as ErrorCodes;

  // ================================
  // functions
  // ================================
  const handleSuccess = () => {
    navigate(WebRoutes.VERIFY_OTP);
  };

  // ================================
  // side effects
  // ================================
  useEffect(() => {
    if (authSuccess) {
      if (authSuccess === 'S-10002') {
        showToast(getSuccessMessage(authSuccess), 'success');
        handleSuccess();
      }
    }
    if (authFailure) {
      showToast(getErrorMessage(authFailure), 'failure');
    }
    // clean up
    return () =>
      resetMessage(() => dispatch(resetAuthMessage()));
  }, [authSuccess, authFailure]);
  
  return <LoginForm />;
};